var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('polygon',{staticClass:"rightPolygon",attrs:{"points":_vm.rightPolygon}})])}
var staticRenderFns = []

export { render, staticRenderFns }